"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContextFactory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function createContextFactory(name) {
    const context = (0, react_1.createContext)(undefined);
    context.displayName = name;
    function createProvider(t) {
        return ({ children }) => {
            return (0, jsx_runtime_1.jsx)(context.Provider, Object.assign({ value: t }, { children: children }));
        };
    }
    function useHook() {
        const t = (0, react_1.useContext)(context);
        if (!t) {
            throw new Error(`Attempted to use context outside of <${name}Provider /> scope.`);
        }
        return t;
    }
    return [createProvider, useHook];
}
exports.createContextFactory = createContextFactory;
//# sourceMappingURL=factory.js.map